
var mixin = {
  methods: {
    swapItems (arr, index1, index2) {
      arr[index1] = arr.splice(index2, 1, arr[index1])[0]
      return arr
    },
    addZero (val) {
      return val >= 10 ? val : '0' + val
    },
    getTimer () {
      let date = new Date();
      return date.getFullYear() + '/' + this.addZero(date.getMonth() + 1) + '/' + this.addZero(date.getDate()) + ' ' + this.addZero(date.getHours()) + ':' + this.addZero(date.getMinutes())
    },
    call (contact) {
      contact.timer = this.getTimer()
      let ctt = JSON.parse(localStorage.getItem('TIO')).database.contacts
      if (!this.contacts.some(item => item.mobile === contact.mobile)) {
          this.$store.dispatch('home/setContacts', [contact, ...this.contacts])
      } else {
        ctt.forEach((item, index) => {
              if (item.mobile === contact.mobile) {
                  contact.timer = this.getTimer()
                  ctt.splice(index, 1)
                  this.$store.dispatch('home/setContacts', [contact, ...ctt])
              }
          })
      }
    }
  }
}

export default mixin
